import React, { useEffect, useRef, useState, useCallback } from "react";
import { createReactEditorJS } from 'react-editor-js';
import { EDITOR_JS_TOOLS } from './tools';
import { useNavigate } from "react-router-dom";
import './EditorComponent.css';
import axios from 'axios';
import api from '../../api.js';

const EditorComponent = ({ rif, isNewAnalisi, data, funshowModal, path }) => {
  const [isNew, setIsNew] = useState(false);
  const [showToc, setShowToc] = useState(true);
  const [headers, setHeaders] = useState([]);

  const navigate = useNavigate();
  const ReactEditorJS = createReactEditorJS();
  const editorCore = useRef(null);

  // Extract headers from data on mount and store them in state
  // so they persist even if EditorJS re-renders internally
  useEffect(() => {
    if (data && data.blocks) {
      const h = data.blocks
        .filter(el => el.type === "header")
        .map(el => el.data.text);
      setHeaders(h);
    }
  }, [data]);

  const isNewRef = useRef(isNew);
  useEffect(() => {
    isNewRef.current = isNew;
  }, [isNew]);

  const isNewAnalisiRef = useRef(isNewAnalisi);
  useEffect(() => {
    isNewAnalisiRef.current = isNewAnalisi;
  }, [isNewAnalisi]);

  const handleInitialize = useCallback((instance) => {
    editorCore.current = instance;
  }, []);
  
  const handleSave = useCallback(async () => {
    if (!editorCore.current) return;
    try {
      const savedData = await editorCore.current.save();
      const currentlyNewAnalisi = isNewAnalisiRef.current;
      const currentlyNew = isNewRef.current;

      if (!currentlyNewAnalisi && !currentlyNew) {
        setIsNew(true);
        isNewRef.current = true;
        let apiReqCre = path ? `${api()}${path}createEditorHistory` : `${api()}/editor/createEditor`;
        
        axios.post(`${apiReqCre}`, {
          uni: rif,
          editor: savedData,
          headers: {
            authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then((res) => console.log(res.data))
        .catch((err) => console.error(err));
      } else {
        let apiReqUpd = path ? `${api()}${path}updateDataHistory` : `${api()}/editor/updateData`;
        axios.post(`${apiReqUpd}`, {
          uni: rif,
          editor: savedData,
          headers: {
            authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then((res) => console.log(res.data))
        .catch((err) => console.error(err));
      }
    } catch (e) {
      console.error('Error saving editor data:', e);
    }
  }, [path, rif]);

  useEffect(() => {
    if (data && data?.blocks) {
      setTimeout(() => {
        const textareas = document.querySelectorAll('.ce-rawtool__textarea');
        textareas.forEach((textarea, index) => {
          if (textarea.parentNode.querySelector('.redoc-container')) return;
          const html = textarea.value;
          const redoc = document.createElement('div');
          redoc.className = 'redoc-container';
          textarea.parentNode.insertBefore(redoc, textarea.nextSibling);
          
          const container = document.createElement('div');
          container.innerHTML = html;

          const scripts = container.querySelectorAll('script');
          const scriptPromises = [];

          scripts.forEach(script => {
            const newScript = document.createElement('script');
            if (script.src) {
              newScript.src = script.src;
              newScript.async = false;
              scriptPromises.push(new Promise(resolve => {
                newScript.onload = resolve;
              }));
            } else {
              newScript.textContent = script.textContent;
            }
            document.body.appendChild(newScript);
            script.remove();
          });

          Promise.all(scriptPromises).then(() => {
            const outputContainer = document.createElement('div');
            outputContainer.className = `output-container-${index}`;
            outputContainer.appendChild(container);
            redoc.appendChild(outputContainer);
          });
        });
      }, 800);
    }
  }, [data]);

  const goToDefinition = (elText) => {
    // Search only inside the editor content area to avoid sidebar self-scroll
    const editorArea = document.querySelector('.editor-content-area');
    if (!editorArea) return;
    const headings = editorArea.querySelectorAll('h1, h2, h3, h4, h5, h6');
    headings.forEach((heading) => {
      if (heading.textContent.trim() === elText.trim()) {
        heading.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  };

  const handleClose = () => {
    if (funshowModal) {
      funshowModal();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="editor-page-wrapper">
      {/* Sticky Top Control Bar */}
      <div className="editor-top-bar">
        <button className="btn-editor-back" onClick={handleClose}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          Torna alla vista tabella
        </button>

        <div className="editor-title-badge">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg>
          <span>Documento: <strong>{rif || 'Nuovo'}</strong></span>
        </div>

        <div className="editor-actions-right">
          <button className="btn-editor-toc-toggle" onClick={() => setShowToc(!showToc)}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
            {showToc ? 'Nascondi Indice' : 'Mostra Indice'}
          </button>
        </div>
      </div>

      {/* Editor Body — TOC + Content side by side */}
      <div className="editor-main-body">
        {/* TOC Sidebar */}
        {showToc && (
          <aside className="editor-toc-sidebar">
            <div className="toc-sidebar-header">
              <span>Indice Sezioni</span>
              <span className="toc-count-chip">{headers.length}</span>
            </div>
            <ul className="toc-list">
              {headers.length === 0 ? (
                <li className="toc-empty">Nessuna intestazione trovata</li>
              ) : (
                headers.map((headingText, idx) => (
                  <li key={idx} onClick={() => goToDefinition(headingText)} className="toc-item">
                    <span className="toc-bullet">•</span>
                    <span className="toc-text">{headingText}</span>
                  </li>
                ))
              )}
            </ul>
          </aside>
        )}

        {/* Main EditorJS Workspace */}
        <div className="editor-content-area">
          <div className="editor-paper-card">
            <ReactEditorJS 
              onChange={handleSave} 
              defaultValue={data} 
              onInitialize={handleInitialize}  
              tools={EDITOR_JS_TOOLS} 
              path={path} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditorComponent;